import React, { useState } from 'react';
import styled from 'astroturf/react';

import type { Props } from 'js/logged_out_bucketing_bar/types';

const BucketingPanel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "logged-out-bucketing-bar" */ 'js/logged_out_bucketing_bar/BucketingPanel'
    ),
);

// A column, so the panel stacks above a bar that has wrapped to several lines.
const Dock = styled.div`
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 2147483000;
`;

const Bar = styled.div`
  align-items: center;
  background: #000;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  font-family: 'Roboto Mono', monospace;
  font-size: 12px;
  gap: 10px;
  line-height: 1.4;
  padding: 8px 12px;
`;

const Title = styled.span`
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const Detail = styled.span`
  color: #bbb;
`;

// Removed by the follow-up that wires selections to bucketing. Until then a
// tester who forces an arm and sees no change is hitting the exact silent no-op
// this bar exists to remove, so say so.
const Inert = styled.span`
  color: #f0b429;
`;

const Toggle = styled.button`
  background: transparent;
  border: 1px solid #fff;
  border-radius: 18px;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  padding: 4px 12px;

  &:hover {
    background: #fff;
    color: #000;
  }
`;

const LoggedOutBucketingBar: React.FC<Props> = ({ tests }) => {
  const [expanded, setExpanded] = useState(false);

  const forcedCount = tests.filter((test) => test.override != null).length;

  return (
    <Dock>
      {expanded && (
        <React.Suspense fallback={null}>
          <BucketingPanel tests={tests} />
        </React.Suspense>
      )}
      <Bar>
        <Title>Logged-out test override</Title>
        <Detail>
          {forcedCount === 0 ? 'no arm forced' : `${forcedCount} arm(s) forced`}
        </Detail>
        <Inert>· preview only, selections do not change bucketing yet</Inert>
        <Toggle onClick={() => setExpanded(!expanded)}>
          {expanded ? 'close' : 'pick an arm'}
        </Toggle>
      </Bar>
    </Dock>
  );
};

export default LoggedOutBucketingBar;
